var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card mb-3" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body px-1" },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("card-content-separator", {
          attrs: { "icon-class": "icon-Add text-gray2" },
        }),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("card-content-separator", {
          attrs: { "icon-class": "icon-equal text-gray2" },
        }),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-12 ob1-skeleton" }, [
      _c("div", {
        staticClass: "ob1-skeleton-white mb-1",
        staticStyle: { width: "100%", height: "30px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "d-flex flex-row mb-1 justify-content-between" },
      [
        _c("div", { staticClass: "col-8 ob1-skeleton" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "100%", height: "32px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "60%", height: "22px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "60%", height: "22px" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ob1-skeleton" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "60px", height: "60px" },
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "d-flex flex-row my-1 justify-content-between" },
      [
        _c("div", { staticClass: "col-8 ob1-skeleton" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "100%", height: "32px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "60%", height: "22px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "60%", height: "22px" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ob1-skeleton" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "60px", height: "60px" },
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "d-flex flex-row my-1 justify-content-between" },
      [
        _c("div", { staticClass: "col-12 ob1-skeleton" }, [
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "40%", height: "40px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "30%", height: "20px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "30%", height: "20px" },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "ob1-skeleton-white mb-1",
            staticStyle: { width: "100%", height: "40px" },
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "ob1-skeleton mb-1" }, [
      _c("div", {
        staticClass: "ob1-skeleton-white mb-1",
        staticStyle: { width: "100%", height: "50px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }